module.exports = __webpack_public_path__ + "static/homepage_hero1-a3e7416d97a41ee1ed9ef7b7f238b171.jpg";